var _rect, _line, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6, _circle, _line2, _line3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _path3, _path4, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsiteTrafficAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 81,
    width: 199,
    height: 199,
    rx: 24,
    stroke: "#192657",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: 107,
    x2: 270,
    y2: 107,
    stroke: "#192657",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 92,
    width: 40,
    height: 6,
    rx: 3,
    fill: "#528FF5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 92,
    width: 101,
    height: 6,
    rx: 3,
    fill: "#528FF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131 95C131 93.3431 132.343 92 134 92C135.657 92 137 93.3431 137 95C137 96.6569 135.657 98 134 98C132.343 98 131 96.6569 131 95Z",
    fill: "#528FF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141 95C141 93.3431 142.343 92 144 92C145.657 92 147 93.3431 147 95C147 96.6569 145.657 98 144 98C142.343 98 141 96.6569 141 95Z",
    fill: "#528FF5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 194,
    width: 53,
    height: 6,
    rx: 3,
    fill: "#F58120"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 270,
    y: 213,
    width: 37,
    height: 6,
    rx: 3,
    fill: "#F58120"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 97,
    y: 129,
    width: 148,
    height: 24,
    rx: 12,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 141,
    r: 6,
    fill: "#F58120",
    stroke: "#192657",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 117.315,
    y1: 144.493,
    x2: 123.8,
    y2: 148.846,
    stroke: "#192657",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 131,
    y1: 128,
    x2: 131,
    y2: 154,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 145.5,
    cy: 141.5,
    r: 3.5,
    fill: "#528FF5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.5,
    cy: 141.5,
    r: 3.5,
    fill: "#528FF5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 167.5,
    cy: 141.5,
    r: 3.5,
    fill: "#528FF5"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 178.5,
    cy: 141.5,
    r: 3.5,
    fill: "#528FF5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.5,
    cy: 141.5,
    r: 3.5,
    fill: "#528FF5"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 200.5,
    cy: 141.5,
    r: 3.5,
    fill: "#528FF5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 213,
    width: 15,
    height: 43,
    fill: "#F58120"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 200,
    width: 15,
    height: 56,
    fill: "#528FF5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 151,
    y: 219,
    width: 15,
    height: 37,
    fill: "#F58120"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 189,
    width: 15,
    height: 67,
    fill: "#528FF5"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 204,
    width: 15,
    height: 52,
    fill: "#F58120"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 189,
    width: 15,
    height: 67,
    fill: "#528FF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54 187L36 147.5L54 114.5L32.5 68L76 38.5L127.5 66",
    stroke: "#192657",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M245 320.5L301 312L314.5 263",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 148.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 188.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 246.5,
    cy: 319.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 54.5,
    cy: 115.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 69.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.5,
    cy: 39.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 127.5,
    cy: 65.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.5,
    cy: 312.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 314.5,
    cy: 263.5,
    r: 6.5,
    fill: "white",
    stroke: "#192657",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M291.501 122.5C252.334 76.6668 159.201 -6.59982 100.001 27.0002C26.0007 69.0002 -42.4993 227.5 40.0007 293C122.501 358.5 331.5 358.5 334.5 276C337.5 193.5 263.5 124 244 138.5",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteTrafficAnalysis);
export default __webpack_public_path__ + "static/media/WebsiteTrafficAnalysis.f3770f7d455c15cfbade26f457b94f8e.svg";
export { ForwardRef as ReactComponent };